var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value >= 3)?_c('span',{class:{ 'text-success': _vm.value >= 3 && _vm.value < 10, 'text-rose': _vm.value >= 10 && _vm.value < 20, bold: _vm.value >= 20 }},[_vm._v(_vm._s(_vm.value)+"'")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }